import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'letter-n', 'LetterN', [["path",{"d":"M7 20v-16l10 16v-16","key":"svg-0"}]]);